export default __webpack_public_path__ + "static/media/featureThree.fb423229.svg";